import { OnTagAttrHandler } from 'xss';

export const sanitizeLink: OnTagAttrHandler = (tag, name, value) => {
  // NOTE: Если target="_blank", то насильно проставляем rel="noopener noreferrer" на всякий случай

  if (tag === 'a') {
    return name === 'target' && value === '_blank' ? 'target="_blank" rel="noopener noreferrer"' : undefined;
  }

  return undefined;
};
